import React from 'react';

export interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  body?: React.ReactNode;
  cta?: React.ReactNode;
  className?: string;
}

/**
 * Standart boş-durum kartı. AppASOPage/ASOKeywordsPage'deki en iyi mevcut pattern
 * (icon + title + body, dashed border) genelleştirilmiş hali — dashed border card.
 */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, body, cta, className }) => (
  <div
    className={`rounded-xl border border-dashed border-gray-300 dark:border-gray-600 p-8 text-center ${className ?? ''}`}
  >
    <div className="w-8 h-8 mx-auto text-gray-400 mb-3">{icon}</div>
    <p className="text-sm font-medium text-gray-900 dark:text-white">{title}</p>
    {body ? <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{body}</p> : null}
    {cta ? <div className="mt-4">{cta}</div> : null}
  </div>
);

export default EmptyState;
